import type { Provider } from '../events.js';

const STORAGE_KEY = 'analytics.loginMethod';
const PROVIDERS: readonly Provider[] = ['google', 'microsoft'];

export function stashLoginMethod(provider: Provider): void {
  sessionStorage.setItem(STORAGE_KEY, provider);
}

export function peekLoginMethod(): Provider | undefined {
  return parseProvider(sessionStorage.getItem(STORAGE_KEY));
}

export function takeLoginMethod(): Provider | undefined {
  const provider = peekLoginMethod();
  sessionStorage.removeItem(STORAGE_KEY);
  return provider;
}

function parseProvider(value: string | null): Provider | undefined {
  return PROVIDERS.find((provider) => provider === value);
}
